// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper_business-F1uh9";
var _3 = "active-vw4Ig";
var _4 = "flightPrice__prefix-19TEr";
var _5 = "flightPrice__wrapper-aBech";
var _6 = "price-1Zlea";
export { _1 as "__esModule", _2 as "wrapper_business", _3 as "active", _4 as "flightPrice__prefix", _5 as "flightPrice__wrapper", _6 as "price" }
export default { "__esModule": _1, "wrapper_business": _2, "active": _3, "flightPrice__prefix": _4, "flightPrice__wrapper": _5, "price": _6 }
